const baseUrl = process.env.VUE_APP_CUSTOMILY_STOREFRONT_SERVICE_API_URL;

export const generateColorImages = async (data: {
    imagePath: string;
    colors: string[];
}): Promise<{ color: string; path: string }[]> => {
    const { imagePath, colors } = data;

    const body = {
        imagePath: imagePath,
        colors: colors
    };

    const response = await fetch(`${baseUrl}/color-images-generator/generate`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        const error = await response.json();
        let messageValue = '';

        try {
            const parsedMessage = JSON.parse(error.message) as {
                error: { message: string };
            };
            messageValue = parsedMessage?.error?.message;
        } catch {
            messageValue = error.message;
        }

        const message = `Failed to generate image effects: ${messageValue || response.statusText}`;
        throw new Error(message);
    }

    return await response.json();
};
